import { sendMeshRecommendsClickedEvent } from 'constants/mixpanelHelper';

import { NudgeCard } from '../types/nudgeCard';

export const openInNewTab = (url: string) => {
  window.open(url, '_blank');
};

export const openInSameTab = (history, url: string) => {
  let cleanSearchParams = url;
  if (cleanSearchParams.startsWith('/')) {
    cleanSearchParams = cleanSearchParams.substring(1);
  }
  if (cleanSearchParams.startsWith('?')) {
    cleanSearchParams = cleanSearchParams.substring(1);
  }
  history.replace({
    search: `?${cleanSearchParams}`,
  });
};

export const handleActionClick = ({
  ecaId,
  uiTemplate,
  action,
}: Pick<NudgeCard, 'ecaId' | 'uiTemplate'> & { action: () => void }) => {
  sendMeshRecommendsClickedEvent({
    eventProperties: {
      ecaId,
      source: 'HOME_PAGE',
      type: uiTemplate,
    },
  });
  action();
};
